import { FC, ReactNode, useCallback, useLayoutEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import classNames from "classnames";

interface CarouselProps {
  containerClassName?: string;
  children: ReactNode;
}

const Carousel: FC<CarouselProps> = ({ containerClassName, children }) => {
  const scrollRowRef = useRef<HTMLDivElement>(null);
  const [leftFadeWidth, setLeftFadeWidth] = useState<number>();
  const [rightFadeWidth, setRightFadeWidth] = useState<number>();

  const calculateFadeWidths = useCallback((target: HTMLDivElement) => {
    const { scrollLeft, scrollWidth, offsetWidth: width } = target;
    const pixelsToRight = scrollWidth - scrollLeft - width;
    setLeftFadeWidth(Math.min(scrollLeft, 40));
    setRightFadeWidth(Math.min(pixelsToRight, 40));
  }, []);

  useLayoutEffect(() => {
    if (scrollRowRef.current === null) return;
    calculateFadeWidths(scrollRowRef.current);
  }, [calculateFadeWidths]);

  return (
    <div className={classNames(styles.container, containerClassName)}>
      <div className={styles.leftFade} style={{ width: leftFadeWidth }} />
      <div
        ref={scrollRowRef}
        className={styles.scrollRow}
        onScroll={({ currentTarget }) => calculateFadeWidths(currentTarget)}>
        <div className={styles.content}>{children}</div>
      </div>
      <div className={styles.rightFade} style={{ width: rightFadeWidth }} />
    </div>
  );
};

export default Carousel;
